const Terms = () => {
    return (
        <div className="relative py-16 bg-white overflow-hidden">
            <div className="relative px-4 sm:px-6 lg:px-8">
                <div className="text-lg max-w-prose mx-auto">
                    <h1>
                        <span className="block text-base text-center text-indigo-600 font-semibold tracking-wide uppercase">
                            Scoutli.co
                        </span>

                        <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                            Privacy & Terms
                        </span>
                    </h1>

                    <p className="mt-8 text-xl text-gray-500 leading-8">
                        Thank you for choosing to be part of our community at Scoutli ("Company", "we", "us", "our")! We
                        are committed to protecting your personal information and your right to privacy. If you have any
                        questions or concerns about this privacy notice or our practices with regards to your personal
                        information, please contact us at <b>team@scoutli.co</b>.
                    </p>
                </div>
                <div className="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto gap-x-4">
                    <p>
                        When you and more generally, use any of our services (the "Services", which include the ), we
                        appreciate that you are trusting us with your personal information. We take your privacy very
                        seriously. In this privacy notice, we seek to explain to you in the clearest way possible what
                        information we collect, how we use it, and what rights you have in relation to it. We hope you
                        take some time to read through it carefully, as it is important. If there are any terms in this
                        privacy notice that you do not agree with, please discontinue use of our Services immediately.
                    </p>

                    <p>
                        This Privacy Policy applies only to your use of Our Site. It does not extend to any websites
                        that are linked to Our Site (whether We provide those links or whether they are shared by other
                        users). We have no control over how your data is collected, stored, or used by other websites
                        and We advise you to check the privacy policies of any such websites before providing any data
                        to them.
                    </p>

                    <p>
                        This privacy notice applies to all information collected through our Services (which, as
                        described above, includes our), as well as, any related services, sales, marketing or events.
                    </p>

                    <p>
                        Please read this privacy notice carefully as it will help you understand what we do with the
                        information that we collect
                    </p>

                    <h2>Table of Contents</h2>

                    <ul role="list" className="list-decimal">
                        <li>WHAT INFORMATION DO WE COLLECT?</li>
                        <li>WILL YOUR INFORMATION BE SHARED WITH ANYONE?</li>
                        <li>DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</li>
                        <li>HOW LONG DO WE KEEP YOUR INFORMATION?</li>
                        <li>DO WE COLLECT INFORMATION FROM MINORS?</li>
                        <li>WHAT ARE YOUR PRIVACY RIGHTS?</li>
                        <li>CONTROLS FOR DO-NOT-TRACK FEATURES</li>
                        <li>HOW CAN YOU REVIEW, UPDATE OR DELETE THE DATA WE COLLECT FROM YOU?</li>
                        <li>DO WE MAKE UPDATES TO THIS NOTICE?</li>
                        <li>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</li>
                        <li>CCPA PRIVACY POLICY (DO NOT SELL MY PERSONAL INFORMATION)</li>
                        <li>GDPR PRIVACY POLICY (DATA PROTECTION RIGHTS)</li>
                        <li>CHILDREN'S PRIVACY</li>
                    </ul>

                    <h3>1. WHAT INFORMATION DO WE COLLECT?</h3>

                    <p>
                        We collect some information including name, business name, business logo, user image, contact
                        information, notification channel addresses that you provide to us voluntarily. Information
                        about IP address, web browser information, operating system, and the list of URLs for referring
                        Scoutli and user activity on Scoutli have collected automatically.
                    </p>

                    <h4>The personal information you disclose to us</h4>

                    <p>
                        We collect personal information that you voluntarily provide to us when you register on the
                        express an interest in obtaining information about us or our products and services when you
                        contact us. Some data will be collected automatically by Scoutli.
                    </p>

                    <p>
                        All personal information that you provide to us must be true, complete, and accurate, and you
                        must notify us of any changes to such personal information.
                    </p>

                    <p>
                        The personal information that we collect depends on the context of your interactions with us and
                        the choices you make and the products and features you use.
                    </p>

                    <h4>Information automatically collected</h4>

                    <p>
                        We automatically collect certain information when you visit, use or navigate. This information
                        does not reveal your specific identity (like your name or contact information) but may include
                        device and usage information, such as your IP address, browser, and device characteristics,
                        operating system, language preferences, referring URLs, device name, country, location,
                        information about how and when you use our and other technical information. This information is
                        primarily needed to maintain the security and operation of our, and for our internal analytics
                        and reporting purposes
                    </p>

                    <p>
                        Like many businesses, we also collect information through cookies and similar technologies.
                    </p>

                    <h3>2. WILL YOUR INFORMATION BE SHARED WITH ANYONE?</h3>

                    <p>We may process or share the data that we hold based on the following legal basis:</p>

                    <p>
                        More specifically, we may need to process your data or share your personal information in the
                        following situations:
                    </p>

                    <ul role="list">
                        <li>
                            Business Transfers: We may share or transfer your information in connection with, or during
                            negotiations of, any merger, sale of company assets, financing, or acquisition of all or a
                            portion of our business to another company.
                        </li>
                        <li>
                            Business Partners: We may share your information with our business partners to offer you
                            certain products, services, or promotions.
                        </li>
                        <li>
                            Payment Processors: We may share your data with payment processors and email services. A
                            payment processor may save your billing information. You may find out or more information
                            about the privacy policy of the payment processor.
                        </li>

                        <li>
                            Virtual Server Providers: We may share your data with Virtual Server Providers to store your
                            data securely.
                        </li>
                    </ul>

                    <h3>3. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h3>

                    <p>
                        We may use cookies and similar tracking technologies (like web beacons and pixels) to access or
                        store information.
                    </p>

                    <h4>Log Data</h4>

                    <p>
                        Scoutli follows a standard procedure of using log files. These files log visitors when they visit
                        websites. All hosting companies do this and are a part of hosting services' analytics. The
                        information collected by log files includes internet protocol (IP) addresses, browser type,
                        Internet Service Provider (ISP), date and time stamp, referring/exit pages, your device model,
                        operating system, unique device identifier, mobile network carrier, time zone, location and
                        possibly the number of clicks. These are not linked to any information that is personally
                        identifiable. The purpose of the information is for analyzing trends, administering the site,
                        tracking users' behavior on the website, and gathering demographic information.
                    </p>

                    <h4>Cookie Data</h4>

                    <p>
                        Like any other website, Scoutli uses ‘cookies'. These cookies are used to store information
                        including visitors' preferences, and the pages on the website that the visitor accessed or
                        visited. The information is used to optimize the users' experience by customizing our web page
                        content based on visitors' browser type and/or other information.
                    </p>

                    <h4>Analytics</h4>

                    <p>
                        Scoutli may use some third-party Service Providers such as Google Analytics and Google Tag
                        Manager in order to get some analytics and Viewer interactions services.</p>

                    <h3>4. HOW LONG DO WE KEEP YOUR INFORMATION?</h3>

                    <p>
                        We will only keep your personal information for as long as it is necessary for the purposes set
                        out in this privacy notice unless a longer retention period is required or permitted by law
                        (such as tax, accounting, or other legal requirements).
                    </p>

                    <p>
                        When we have no ongoing legitimate business need to process your personal information, we will
                        either delete or anonymize such information or, if this is not possible (for example, because
                        your personal information has been stored in backup archives), then we will securely store your
                        personal information and isolate it from any further processing until deletion is possible.
                    </p>

                    <h3>5. DO WE COLLECT INFORMATION FROM MINORS?</h3>

                    <p>
                        We do not knowingly solicit data from or market to children under 18 years of age. By using the,
                        you represent that you are at least 18 or that you are the parent or guardian of such a minor
                        and consent to such minor dependent’s use of the. If we learn that personal information from
                        users less than 18 years of age has been collected, we will deactivate the account and take
                        reasonable measures to promptly delete such data from our records. If you become aware of any
                        data we may have collected from children under age 18, please contact us
                        at <b>team@scoutli.co</b>.
                    </p>

                    <h3>6. WHAT ARE YOUR PRIVACY RIGHTS?</h3>

                    <h4>Account Information</h4>

                    <p>
                        If you would at any time like to review or change the information in your account or terminate
                        your account, you can:
                    </p>

                    <p>
                        Upon your request to terminate your account, we will deactivate or delete your account and
                        information from our active databases. However, we may retain some information in our files to
                        prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use,
                        and/or comply with applicable legal requirements.
                    </p>

                    <p>Opting out of email marketing: You can unsubscribe from our marketing email list at any time by
                        clicking on the unsubscribe link in the emails that we send or by contacting us using the
                        details provided below. You will then be removed from the marketing email list — however, we may
                        still communicate with you, for example, to send you service-related emails that are necessary
                        for the administration and use of your account, to respond to service requests, or for other
                        non-marketing purposes.
                    </p>

                    <h4>Cookies</h4>

                    <p>
                        You may also refrain from providing or may withdraw your consent for cookies via your browser
                        settings. Please keep in mind that in order to use Scoutli, some Cookies are often required.
                    </p>

                    <h4>Analytics Services</h4>

                    <p>
                        You may opt-out of Google Analytics’ services using the Opt-Out feature on their website. The
                        Google Analytics service is provided by Google Inc. For more information about the privacy
                        policies of Google, please visit Google's privacy policies: <a
                        href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>
                    </p>

                    <h3>7. CONTROLS FOR DO-NOT-TRACK FEATURES</h3>

                    <p>
                        Most web browsers and some mobile operating systems and mobile applications include a
                        Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not
                        to have data about your online browsing activities monitored and collected. At this stage, no
                        uniform technology standard for recognizing and implementing DNT signals has been finalized. As
                        such, we do not currently respond to DNT browser signals or any other mechanism that
                        automatically communicates your choice not to be tracked online. If a standard for online
                        tracking is adopted that we must follow in the future, we will inform you about that practice in
                        a revised version of this privacy notice.
                    </p>

                    <h3>
                        8. HOW CAN YOU REVIEW, UPDATE OR DELETE THE DATA WE COLLECT FROM YOU?
                    </h3>

                    <p>
                        In connection with the fact that Scoutli processes your personal data, you have the right to
                        request access to your data, to rectify, delete them or restrict processing thereof. You also
                        have the right to object to the processing of your personal data by Scoutli, and to move your
                        personal data.
                    </p>

                    <ul role="list">
                        <li>
                            <b>Right to lodge a complaint</b>
                            <p>
                                Please be informed that in connection with the processing of your personal data by
                                Scoutli you have the right to lodge a complaint to the supervisory authority.
                            </p>
                        </li>

                        <li>
                            <b>Right to object</b>
                            <p>
                                Please be informed that in the cases in which we process your personal data you have the
                                right to object to such processing of your personal data by Us at any time - due to
                                reasons connected with your special situation.
                            </p>
                            <p>
                                As for our processing of your personal data for the needs of direct marketing, including
                                profiling, you have the right to object to such processing of your personal data by
                                scoutli.co to the extent to which our processing of your personal data is connected with
                                direct marketing.
                            </p>
                        </li>

                        <li>
                            <b> Right to withdraw consent</b>
                            <p>
                                You have the right to withdraw consent for the processing of personal data at any time.
                                Processing of personal data by Scoutli is legal from the moment when the consent is
                                given until the moment of its withdrawal, i.e. the moment when Scoutli.
                            </p>
                        </li>
                    </ul>

                    <h3>9. DO WE MAKE UPDATES TO THIS NOTICE?</h3>

                    <p>
                        We may update this privacy notice from time to time. The updated version will be indicated by an
                        updated "Revised" date and the updated version will be effective as soon as it is accessible. We
                        encourage you to review this privacy notice frequently to be informed of how we are protecting
                        your information. If you continue to use Scoutli after those changes are in effect, you agree to
                        the revised Notice.
                    </p>

                    <p>
                        By using our website, you hereby consent to our Privacy Policy and agree to its Terms of
                        Service.
                    </p>

                    <h3>
                        10. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
                    </h3>

                    <p>
                        If you have any questions or comments about this notice, you may email us
                        at <b>team@scoutli.co</b>.
                    </p>

                    <h3>
                        11. CCPA Privacy Policy (Do Not Sell My Personal Information)
                    </h3>

                    <p>Under the CCPA, among other rights, California consumers have the right to:</p>

                    <p>
                        Request that a business that collects a consumer's personal data disclose the categories and
                        specific pieces of personal data that a business has collected about consumers.
                    </p>

                    <p>
                        Request that a business deletes any personal data about the consumer that a business has
                        collected.
                    </p>

                    <p>
                        Request that a business that sells a consumer's personal data, not sell the consumer's personal
                        data.
                    </p>

                    <p>
                        If you make a request, we have one month to respond to you. If you would like to exercise any of
                        these rights, please contact us at <b>team@scoutli.co</b>.
                    </p>

                    <h3>12. GDPR Privacy Policy (Data Protection Rights)</h3>

                    <p>
                        We would like to make sure you are fully aware of all of your data protection rights. Every user
                        is entitled to the following:
                    </p>

                    <p>
                        <b>The right to access –</b> You have the right to request copies of your personal data. We may
                        charge
                        you a small fee for this service.
                    </p>

                    <p>
                        <b>The right to rectification –</b> You have the right to request that we correct any
                        information you
                        believe is inaccurate. You also have the right to request that we complete the information you
                        believe is incomplete.
                    </p>

                    <p>
                        <b>The right to erasure –</b> You have the right to request that we erase your personal data,
                        under
                        certain conditions.
                    </p>

                    <p>
                        <b>The right to restrict processing –</b> You have the right to request that we restrict the
                        processing
                        of your personal data, under certain conditions.
                    </p>

                    <p>
                        <b>The right to object to processing – </b> You have the right to object to our processing of
                        your
                        personal data, under certain conditions.
                    </p>

                    <p>
                        <b>The right to data portability –</b> You have the right to request that we transfer the data
                        that we
                        have collected to another organization, or directly to you, under certain conditions.
                    </p>

                    <p>
                        If you make a request, we have one month to respond to you. If you would like to exercise any of
                        these rights, please contact us at <b>team@scoutli.co</b>.
                    </p>

                    <h3>13. Children's Privacy</h3>

                    <p>
                        We encourage parents and guardians to observe, participate in, and/or monitor and guide their
                        online activity. Scoutli does not knowingly collect any Personal Identifiable Information from
                        children under the age of 18. If you think that your child provided this kind of information on
                        our website, we highly encourage you to contact us immediately and we will do our best efforts
                        to promptly remove such information from our records.
                    </p>

                    <p>Esenyalı Mah. Izmir/Turkey 35140</p>

                    <p><b>team@scoutli.co</b></p>

                    <h4>Introduction</h4>

                    <p>Welcome to Scoutli (“Company”, “we”, “our”, “us”)! Please read this document carefully before
                        using our service.
                    </p>

                    <p>
                        These terms of use (these “Terms of Use”) is applicable to all use of and access to the software
                        developed as a software as a service and supplied by Scoutli and any additional services (the
                        “Services”) that may be provided by Scoutli (“Scoutli”, “We”, “Us”, or “Our”) to its users
                        (“User(s)”, “You”, or “Your”).
                    </p>

                    <p>
                        Your agreement with us includes these Terms of Use and our Privacy Policy (“Agreements”). You
                        acknowledge that you have read and understood Agreements, and agree to be bound of them. You
                        will accept electronically these Terms of Use at the time of subscription and of the creation of
                        a valid account giving access to the Services (the “Account”) and after each amendment thereof.
                        In any event, these Terms of Use are always accessible on Scoutli's website located at
                        scoutli.co (the “Website”).
                    </p>

                    <p>
                        If you do not agree with (or cannot comply with) Agreements, then you may choose not to use the
                        Service, but please contact us at <b>team@scoutli.co</b> so we can try to find a solution. These
                        Terms
                        apply to all visitors, users, and others who wish to access or use the Service.
                    </p>

                    <h4>Subscriptions</h4>

                    <p>
                        Service is billed on a subscription basis (“Subscription(s)”). You will be billed in advance on
                        a recurring and periodic basis (“Billing Cycle”). Billing cycles are set either on a monthly or
                        annual basis, depending on the type of subscription plan you select when purchasing a
                        Subscription plan.
                    </p>

                    <p>
                        At the end of each Billing Cycle, your Subscription will automatically renew under the exact
                        same conditions unless you cancel it or Scoutli cancels it.
                    </p>

                    <h4>Billing</h4>

                    <p>
                        A valid payment method is required to process the payment for your subscription. You shall
                        provide Scoutli with accurate and complete billing information including full name, address,
                        state, zip code, telephone number, and valid payment method information. By submitting such
                        payment information, you automatically authorize Scoutli to charge all Subscription fees
                        incurred through your account to any such payment instruments.
                    </p>

                    <p>
                        Should automatic billing fail to occur for any reason, Scoutli will cancel your subscription.
                    </p>

                    <p>
                        You have accepted the terms of the payment gateway company.
                    </p>

                    <h4>Free Trial</h4>

                    <p>
                        Scoutli may, at its sole discretion, offer a Subscription with a free trial for a limited period
                        of time (“Free Trial”).
                    </p>

                    <p>
                        It's not required to enter your billing information in order to sign up for Free Trial. You will
                        not be charged by Scoutli until Free Trial has expired. Once your Free Trial period has finished
                        you should start a subscription plan that rights for you to continue using the service provided
                        by Scoutli.
                    </p>

                    <p>
                        At any time and without notice, Scoutli reserves the right to (i) modify Terms of Service of
                        Free Trial offer, or (ii) cancel such Free Trial offer.
                    </p>

                    <h4>Fee Changes</h4>

                    <p>
                        Scoutli, in its sole discretion and at any time, may modify Subscription fees for the
                        Subscriptions. Any Subscription fee change will become effective at the end of the then-current
                        Billing Cycle.
                    </p>

                    <p>
                        Scoutli will provide you with reasonable prior notice of any change in Subscription fees to give
                        you an opportunity to terminate your Subscription before such change becomes effective.
                    </p>

                    <p>
                        Your continued use of Service after the Subscription fee change comes into effect constitutes
                        your agreement to pay the modified Subscription fee amount.
                    </p>

                    <h4>Refund</h4>

                    <p>Except when required by law, paid Subscription fees are non-refundable.</p>

                    <p>
                        Certain refund requests for Subscriptions may be considered by the Company on a case-by-case
                        basis and granted at the sole discretion of the Company.
                    </p>

                    <h4>Communications</h4>

                    <p>
                        By creating an Account on our Service, you agree to subscribe to newsletters, marketing or
                        promotional materials, and other information we may send. However, you may opt-out of receiving
                        any, or all, of these communications from us by following the unsubscribe link or by email.
                    </p>

                    <h4>Purchases</h4>

                    <p>
                        If you wish to purchase any product or service made available through Service (“Purchase”), you
                        may be asked to supply certain information relevant to your Purchase including, without
                        limitation, your credit card number, the expiration date of your credit card, your billing
                        address, and your shipping information.
                    </p>

                    <p>
                        You represent and warrant that: (i) you have the legal right to use any credit card(s) or
                        another payment method (s) in connection with any Purchase; and that (ii) the information you
                        supply to us is true, correct and complete.
                    </p>

                    <p>
                        We may employ the use of third-party services for the purpose of facilitating payment and the
                        completion of Purchases. By submitting your information, you grant us the right to provide the
                        information to these third parties subject to our Privacy Policy.
                    </p>

                    <p>
                        We reserve the right to refuse or cancel your order at any time for reasons including but not
                        limited to product or service availability, errors in the description or price of the product or
                        service, error in your order, or other reasons.
                    </p>

                    <p>
                        We reserve the right to refuse or cancel your order if fraud or an unauthorized or illegal
                        transaction is suspected.
                    </p>

                    <h4>Intellectual Property</h4>

                    <p>
                        The Service and its original content (excluding Content provided by You or other users),
                        features, and functionality are and will remain the exclusive property of the Company and its
                        licensors.
                    </p>

                    <p>
                        The Service is protected by copyright, trademark, and other laws of both the Country and foreign
                        countries.
                    </p>

                    <p>
                        Our trademarks and trade dress may not be used in connection with any product or service without
                        the prior written consent of the Company.
                    </p>

                    <h4>License</h4>

                    <p>
                        Permission is granted to temporarily download one copy of the materials (information or
                        software) on Scoutli's website for personal, non-commercial transitory viewing only. This is the
                        grant of a license, not a transfer of title, and under this license, you may not:
                    </p>

                    <ul role="list">
                        <li>
                            modify or copy the materials;
                        </li>
                        <li>
                            access Scoutli in order to build a similar or competitive website, product, or service;
                        </li>
                        <li>
                            use the materials for any commercial purpose, or for any public display (commercial or
                            non-commercial);
                        </li>
                        <li>
                            attempt to decompile or reverse engineer any software contained on Scoutli's website;
                        </li>
                        <li>
                            remove any copyright or other proprietary notations from the materials;
                        </li>
                        <li>
                            transfer the materials to another person or "mirror" the materials on any other server.
                        </li>
                    </ul>

                    <p>
                        This license shall automatically terminate if you violate any of these restrictions and may be
                        terminated by Scoutli at any time. Upon terminating your viewing of these materials or upon the
                        termination of this license, you must destroy any downloaded materials in your possession
                        whether in electronic or printed format. All copyright and other proprietary notices on Scoutli
                        (or on any content displayed on Scoutli) must be retained on all copies thereof.
                    </p>

                    <h4>Accuracy of Materials</h4>

                    <p>
                        The materials appearing on Scoutli's website could include technical, typographical, or
                        photographic errors. Scoutli does not warrant that any of the materials on its website are
                        accurate, complete, or current. Scoutli may make changes to the materials contained on its
                        website at any time without notice. However, Scoutli does not make any commitment to update the
                        materials.
                    </p>

                    <h4>Modification</h4>

                    <p>
                        Scoutli may revise these terms of service for its website at any time without notice. By using
                        this website you agree to be bound by the then current version of these terms of service.
                    </p>

                    <h4>No Support or Maintenance</h4>

                    <p>
                        You acknowledge and agree that Company will have no obligation to provide you with any support
                        in connection with Scoutli.
                    </p>

                    <p>
                        Excluding any User Content that you may provide, you are aware that all the intellectual
                        property rights, including copyrights, patents, trademarks, and trade secrets, in Scoutli and
                        its content, are owned by Company or Company's suppliers. Note that these Terms and access to
                        Scoutli do not give you any rights, title, or interest in or to any intellectual property
                        rights, except for the limited access rights Company and its supplier's reserve all rights not
                        granted in these Terms.
                    </p>

                    <h4>Links</h4>

                    <p>
                        Scoutli has not reviewed all of the sites linked to its website and is not responsible for the
                        contents of any such linked site. The inclusion of any link does not imply endorsement by
                        Scoutli of the site. Use of any such linked website is at the user's own risk.
                    </p>

                    <p>
                        The Company has no control over and assumes no responsibility for, the content, privacy
                        policies, or practices of any third-party websites or services. You further acknowledge and
                        agree that the Company shall not be responsible or liable, directly or indirectly, for any
                        damage or loss caused or alleged to be caused by or in connection with the use of or reliance on
                        any such content, goods, or services available on or through any such web sites or services.
                    </p>

                    <h4>User Content</h4>

                    <p>“User Content” means any and all information and content that a user submits to Scoutli.</p>

                    <p>
                        You are exclusively responsible for your Content. You bear all risks associated with the use of
                        your User Content. You hereby certify that your Content does not violate our Acceptable Use
                        Policy. You may not represent or imply to others that Your Content is in any way provided,
                        sponsored or endorsed by Company. Because you alone are responsible for your Content, you may
                        expose yourself to liability. The company is not obliged to backup any Content that you post;
                        also, your User Content may be deleted at any time without prior notice to you. You are solely
                        responsible for making your own backup copies of Your Content if you desire.
                    </p>

                    <p>
                        You hereby grant to Company an irreversible, nonexclusive, royalty-free and fully-paid,
                        worldwide license to reproduce, distribute, publicly display and perform, prepare derivative
                        works of, incorporate into other works, and otherwise use and exploit your User Content, and to
                        grant sublicenses of the foregoing rights, solely for the purposes of including your User
                        Content in Scoutli. You hereby irreversibly waive any claims and assertions of moral rights or
                        attribution with respect to your User Content.
                    </p>

                    <p>
                        Scoutli has the right but not the obligation to monitor and edit all Content provided by users.
                    </p>

                    <p>
                        In addition, Content found on or through this Service is the property of Scoutli or used with
                        permission. You may not distribute, modify, transmit, reuse, download, repost, copy, or use said
                        Content, whether in whole or in part, for commercial purposes or for personal gain, without
                        express advance written permission from us.
                    </p>

                    <h4>Acceptable Uses</h4>

                    <p>
                        The following terms constitute our “Acceptable Use Policy”: You agree not to use Scoutli to
                        collect, upload, transmit, display, or distribute any User Content (i) that violates any
                        third-party right or any intellectual property or proprietary right; (ii) that is unlawful,
                        harassing, abusive, tortious, threatening, harmful, invasive of another's privacy, vulgar,
                        defamatory, false, intentionally misleading, trade libelous, pornographic, obscene, patently
                        offensive, promotes racism, bigotry, hatred, or physical harm of any kind against any group or
                        individual; (iii) that is harmful to minors in any way; or (iv) that is in violation of any law,
                        regulation, or obligations or restrictions imposed by any third party.
                    </p>

                    <p>
                        In addition, you agree not to: <b>(I)</b> upload, transmit, or distribute to or through Scoutli
                        any software intended to damage or alter a computer system or data; <b>(II)</b> send through the
                        Scoutli unsolicited or unauthorized advertising, promotional materials, junk mail, spam, chain
                        letters, pyramid schemes, or any other form of duplicative or unsolicited
                        messages; <b>(III)</b> use Scoutli to harvest, collect, gather or assemble information or data
                        regarding other users without their consent; <b>(IV)</b> interfere with, disrupt, or create an
                        undue burden on servers or networks connected to Scoutli, or violate the regulations, policies
                        or procedures of such networks; <b>(V)</b> attempt to gain unauthorized access to Scoutli,
                        whether through password mining or any other means; (vi) harass or interfere with any other
                        user's use and enjoyment of Scoutli; or <b>(VI)</b> use software or automated agents or scripts
                        to produce multiple accounts on Scoutli, or to generate automated searches, requests, or queries
                        to Scoutli.
                    </p>

                    <p>
                        We reserve the right to review any User Content, and to investigate and/or take appropriate
                        action against you in our sole discretion if you violate the Acceptable Use Policy or any other
                        provision of these Terms or otherwise create liability for us or any other person. Such action
                        may include removing or modifying your User Content, terminating your Account in accordance with
                        Section 8, and/or reporting you to law enforcement authorities.
                    </p>

                    <p>
                        You agree to indemnify and hold Company and its officers, employees, and agents harmless,
                        including costs and attorneys' fees, from any claim or demand made by any third party due to or
                        arising out of <b>(A)</b> your use of Scoutli, <b>(B)</b> your violation of these
                        Terms, <b>(C)</b> your violation of applicable laws or regulations or <b>(D)</b> your User
                        Content. The company reserves the right to assume the exclusive defense and control of any
                        matter for which you are required to indemnify us, and you agree to cooperate with our defense
                        of these claims. You agree not to settle any matter without the prior written consent of the
                        Company. The company will use reasonable efforts to notify you of any such claim, action, or
                        proceeding upon becoming aware of it.
                    </p>

                    <h4>Prohibited Uses</h4>

                    <p>
                        You may use Service only for lawful purposes and in accordance with Terms. You agree not to use
                        Service:
                    </p>

                    <ul role="list">
                        <li>In any way that violates any applicable national or international law or regulation.</li>
                        <li>For the purpose of exploiting, harming, or attempting to exploit or harm minors in any way
                            by exposing them to inappropriate content or otherwise.
                        </li>
                        <li>To transmit, or procure the sending of, any advertising or promotional material, including
                            any “junk mail”, “chain letter,” “spam,” or any other similar solicitation.
                        </li>
                        <li>To impersonate or attempt to impersonate Company, a Company employee, another user, or any
                            other person or entity.
                        </li>
                        <li>In any way that infringes upon the rights of others, or in any way is illegal, threatening,
                            fraudulent, or harmful, or in connection with any unlawful, illegal, fraudulent, or harmful
                            purpose or activity.
                        </li>
                        <li>To engage in any other conduct that restricts or inhibits anyone’s use or enjoyment of
                            Service, or which, as determined by us, may harm or offend Company or users of Service or
                            expose them to liability.
                        </li>
                    </ul>

                    <p>Additionally, you agree not to:</p>

                    <ul role="list">
                        <li>Use Service in any manner that could disable, overburden, damage, or impair Service or
                            interfere with any other party’s use of Service, including their ability to engage in
                            real-time activities through Service.
                        </li>
                        <li>Use any robot, spider, or another automatic device, process, or means to access Service for
                            any purpose, including monitoring or copying any of the material on Service.
                        </li>
                        <li>Use any manual process to monitor or copy any of the material on Service or for any other
                            unauthorized purpose without our prior written consent.
                        </li>
                        <li>Use any device, software, or routine that interferes with the proper working of Service.
                        </li>
                        <li>Introduce any viruses, trojan horses, worms, logic bombs, or other material which is
                            malicious or technologically harmful.
                        </li>
                        <li>Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of
                            Service, the server on which Service is stored, or any server, computer, or database
                            connected to Service.
                        </li>
                        <li>Attack Service via a denial-of-service attack or a distributed denial-of-service attack.
                        </li>
                        <li>Take any action that may damage or falsify the Company rating.</li>
                        <li>Otherwise, attempt to interfere with the proper working of Service.</li>
                    </ul>

                    <h4>Analytics</h4>

                    <p>
                        We may use third-party service providers to monitor and analyze the use of our Service.
                    </p>

                    <p>
                        Google Analytics is a web analytics service offered by Google that tracks and reports website
                        traffic. Google uses the data collected to track and monitor the use of our Service. This data
                        is shared with other Google services. Google may use the collected data to contextualize and
                        personalize the ads of its own advertising network.
                    </p>

                    <p>
                        Google Tag Manager is a tag management solution offered by Google that manages the website tags
                        without editing code.
                    </p>

                    <p>
                        For more information on the privacy practices of Google, please visit the Google Privacy Terms
                        web page below: https://policies.google.com/privacy
                    </p>

                    <h4>Cookies</h4>

                    <p>
                        We employ the use of cookies. By accessing scoutli.co, you agreed to use cookies in agreement
                        with Scoutli's Privacy Policy.
                    </p>

                    <p>
                        Most interactive websites use cookies to let us retrieve the user's details for each visit.
                        Cookies are used by our website to enable the functionality of certain areas to make it easier
                        for people visiting our website. Some of our affiliate/advertising partners may also use
                        cookies.
                    </p>

                    <h4>Accounts</h4>

                    <p>
                        You represent that you are over the age of <b>18</b>. The Company does not permit those
                        under <b>18</b> to use the Service. By accessing or using any of the Company, you warrant and
                        represent that you are at least eighteen <b>(18)</b> years of age and with the full authority,
                        right, and capacity to enter into this agreement and abide by all of the terms and conditions of
                        Terms. If you are not at least eighteen <b>(18)</b> years old, you are prohibited from both the
                        access and usage of Service.
                    </p>

                    <p>
                        When you create an account with us, you guarantee that you are above the age of 18 and that the
                        information you provide us is accurate, complete, and current at all times. Inaccurate,
                        incomplete, or obsolete information may result in the immediate termination of your account on
                        Service.
                    </p>

                    <p>
                        You are responsible for maintaining the confidentiality of your account and password, including
                        but not limited to the restriction of access to your computer and/or account. You agree to
                        accept responsibility for any and all activities or actions that occur under your account and/or
                        password, whether your password is with our Service or a third-party service. You must notify us
                        immediately upon becoming aware of any breach of security or unauthorized use of your account.
                    </p>

                    <p>
                        In certain circumstances, you have the following data protection rights:
                    </p>

                    <p>
                        You may not use as a username the name of another person or entity or that is not lawfully
                        available for use, a name or trademark that is subject to any rights of another person or entity
                        other than you, without appropriate authorization. You may not use as a username any name that
                        is offensive, vulgar, or obscene.
                    </p>

                    <p>
                        We reserve the right to refuse service, terminate accounts, remove or edit content, or cancel
                        orders at our sole discretion.
                    </p>

                    <h4>Copyright Policy</h4>

                    <p>
                        If you are a copyright owner or authorized on behalf of one, and you believe that the
                        copyrighted work has been copied in a way that constitutes copyright infringement, please submit
                        your claim via email to <b>team@scoutli.co</b>, with the subject line: “Copyright Infringement”
                        and include in your claim a detailed description of the alleged Infringement as detailed below,
                        under “DMCA Notice and Procedure for Copyright Infringement Claims”
                    </p>

                    <p>
                        You may be held accountable for damages (including costs and attorneys' fees) for
                        misrepresentation or bad-faith claims on the infringement of any Content found on and/or through
                        Service on your copyright.
                    </p>

                    <h4>Error Reporting & Feedback</h4>

                    <p>
                        You assign all rights, title, and interest in any Feedback You provide the Company. If for any
                        reason such assignment is ineffective, You agree to grant the Company a non-exclusive,
                        perpetual, irrevocable, royalty-free, worldwide right and license to use, reproduce, disclose,
                        sub-license, distribute, modify and exploit such Feedback without restriction.
                    </p>

                    <p>
                        If you provide Company with any feedback or suggestions regarding Scoutli, you hereby assign to
                        Company all rights in such Feedback and agree that Company shall have the right to use and fully
                        exploit such Feedback and related information in any manner it believes appropriate. The company
                        will treat any Feedback you provide to Company as non-confidential and non-proprietary.
                    </p>

                    <h4>Disclaimer of Warranty</h4>

                    <p>
                        The materials on Scoutli's website are provided on an 'as-is basis. Scoutli makes no warranties,
                        expressed or implied, and hereby disclaims and negates all other warranties including, without
                        limitation, implied warranties or conditions of merchantability, fitness for a particular
                        purpose, or non-infringement of intellectual property or other violation of rights.
                    </p>

                    <p>
                        Scoutli does not warrant or make any representations concerning the accuracy, likely results, or
                        reliability of the use of the materials on its website or otherwise relating to such materials
                        or on any sites linked to Scoutli.
                    </p>

                    <p>
                        The materials on Scoutli's website are provided on an “as-is” and “as available” basis, and the
                        company and our suppliers expressly disclaim any and all warranties and conditions of any kind,
                        whether express, implied, or statutory, including all warranties or conditions of
                        merchantability, fitness for a particular purpose, title, quiet enjoyment, accuracy, or
                        non-infringement. We and our suppliers make not guarantee that the site will meet your
                        requirements, will be available on an uninterrupted, timely, secure, or error-free basis, or
                        will be accurate, reliable, free of viruses or other harmful code, complete, legal, or safe. If
                        applicable law requires any warranties with respect to the site, all such warranties are limited
                        in duration to ninety (90) days from the date of first use.
                    </p>

                    <h4>Limitation of Liability</h4>

                    <p>
                        We use third-party solutions for software, networking, storage, domain providers, and other
                        technical requirements. To the maximum extent permitted by law, in no event shall Company or our
                        suppliers be liable to you or any third-party for any lost profits, lost data, costs of
                        procurement of substitute products, or any indirect, consequential, exemplary, incidental,
                        special, or punitive damages arising from or relating to these terms or your use of, or
                        incapability to use Scoutli even if the company has been advised of the possibility of such
                        damages. Access to and use of Scoutli is at your own discretion and risk, and you will be solely
                        responsible for any damage to your device or computer system, or loss of data resulting
                        therefrom.
                    </p>

                    <p>
                        To the maximum extent permitted by law, notwithstanding anything to the contrary contained
                        herein, our liability to you for any damages arising from or related to this agreement, will at
                        all times be limited to a maximum of subscription fee that you've paid last one month. The
                        existence of more than one claim will not enlarge this limit. You agree that our suppliers will
                        have no liability of any kind arising from or relating to this agreement.
                    </p>

                    <h4>Termination</h4>

                    <p>
                        Subject to this Section, these Terms will remain in full force and effect while you use Scoutli.
                        We may suspend or terminate your rights to use Scoutli at any time for any reason at our sole
                        discretion, including for any use of Scoutli in violation of these Terms. Upon termination of
                        your rights under these Terms, your Account and right to access and use Scoutli will terminate
                        immediately. You understand that any termination of your Account may involve the deletion of
                        your User Content associated with your Account from our live databases. The company will not
                        have any liability whatsoever to you for any termination of your rights under these Terms.
                    </p>

                    <p>
                        If you wish to terminate your account, you may simply discontinue using Service.
                    </p>

                    <h4>Governing Law</h4>

                    <p>
                        The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your
                        use of the Service. Your use of the Application may also be subject to other local, state,
                        national, or international laws.
                    </p>

                    <p>
                        Our failure to enforce any right or provision of these Terms will not be considered a waiver of
                        those rights. If any provision of these Terms is held to be invalid or unenforceable by a court,
                        the remaining provisions of these Terms will remain in effect. These Terms constitute the entire
                        agreement between us regarding our Service and supersede and replace any prior agreements we
                        might have had between us regarding Service.
                    </p>

                    <h4>Disputes Resolution</h4>

                    <p>If You have any concern or dispute about the Service, You agree to first try to resolve the
                        dispute informally by contacting us at <b>team@scoutli.co</b>.
                    </p>

                    <h4>Changes To Service</h4>

                    <p>
                        We reserve the right to withdraw or amend our Service, and any service or material we provide
                        via Service, in our sole discretion without notice. We will not be liable if for any reason all
                        or any part of Service is unavailable at any time or for any period. From time to time, we may
                        restrict access to some parts of Service, or the entire Service, to users, including registered
                        users.
                    </p>

                    <h4>
                        Indemnification
                    </h4>

                    <p>
                        You hereby indemnify to the fullest extent Company Name from and against any and/or all
                        liabilities, costs, demands, causes of action, damages, and expenses arising in any way related
                        to your breach of any of the provisions of these Terms.
                    </p>

                    <h4>Amendments To Terms</h4>

                    <p>
                        We may amend Terms at any time by posting the amended terms on Scoutli. It is your
                        responsibility to review these Terms periodically. Your continued use of the Platform following
                        the posting of revised Terms means that you accept and agree to the changes. You are expected to
                        check this page frequently so you are aware of any changes, as they are binding on you.
                    </p>

                    <p>
                        By continuing to access or use our Service after any revisions become effective, you agree to be
                        bound by the revised terms. If you do not agree to the new terms, you are no longer authorized
                        to use Service.
                    </p>

                    <p>
                        We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. What
                        constitutes a material change will be determined at Our sole discretion. Customers and Users can
                        review the most current version of the General Terms at any time by visiting this page at <a
                        href="https://scoutli.co/terms">https://scoutli.co/terms</a>.
                    </p>

                    <h4>Entire Agreement</h4>

                    <p>
                        This Agreement, with the Privacy Policy, and any terms disclosed and agreed to by you if you
                        purchase additional features, products, or services we offer on the Service, contains the entire
                        agreement between you and Scoutli regarding the use of the Service. If any provision of this
                        Agreement is held invalid, the remainder of this Agreement shall continue in full force and
                        effect. The failure of the Company to exercise or enforce any right or provision of this
                        Agreement shall not constitute a waiver of such right or provision. You agree that your Scoutli
                        account is non-transferable and all of your rights to your account and its Content terminate
                        upon your death. No agency, partnership, joint venture, or employment is created as a result of
                        this Agreement and you may not make any representations or bind Scoutli in any manner.
                    </p>

                    <p>
                        You agree, to the extent permitted under applicable law, to indemnify, defend and hold harmless
                        Scoutli, our affiliates, and their and our respective officers, directors, agents, and employees
                        from and against any and all complaints, demands, claims, damages, losses, costs, liabilities
                        and expenses, including attorney’s fees, due to, arising out of, or relating in any way to your
                        access to or use of the Services, your Content, or your breach of this Agreement.
                    </p>

                    <p>
                        By using the Service in any manner, you agree to the arbitration agreement. In doing so, YOU
                        GIVE UP YOUR RIGHT TO GO TO COURT to assert or defend any claims between you and the Company
                        (except for matters that may be taken to small-claims court). YOU ALSO GIVE UP YOUR RIGHT TO
                        PARTICIPATE IN A CLASS ACTION OR OTHER CLASS PROCEEDING. Your rights will be determined by a
                        NEUTRAL ARBITRATOR, NOT A JUDGE OR JURY, and the arbitrator shall determine all issues regarding
                        the arbitrability of the dispute. You are entitled to a fair hearing before the arbitrator. The
                        arbitrator can grant any relief that a court can, but you should note that arbitration
                        proceedings are usually simpler and more streamlined than trials and other judicial proceedings.
                        Decisions by the arbitrator are enforceable in court and may be overturned by a court only for
                        very limited reasons.
                    </p>

                    <p>
                        Except as provided herein, the failure to exercise a right or to require performance of an
                        obligation under this Terms shall not affect a party's ability to exercise such right or require
                        such performance at any time thereafter nor shall be the waiver of a breach constitute a waiver
                        of any subsequent breach.
                    </p>

                    <h4>Force Majeure</h4>

                    <p>
                        Except as expressly provided otherwise in the General Terms, Scoutli shall not be liable by
                        reason of any failure or delay in the performance of its obligations on account of an
                        unforeseeable and irresistible event, including external causes with the same characteristics,
                        which may include denial-of-service attacks, a failure by a third-party hosting provider or
                        utility provider, strikes, shortages, riots, fires, the act of God, war, terrorism, and
                        governmental action.
                    </p>

                    <h4>No Other Agreements</h4>

                    <p>
                        The General Terms are the complete and exclusive statement of the Parties’ agreement relating to
                        the subject matter hereof and supersede all oral or written offers, understandings,
                        representations, conditions, warranties, covenants, and other communications between the Parties
                        relating hereto, including any non-disclosure agreements relating to the subject matter hereof.
                    </p>

                    <h4>Notices</h4>

                    <p>
                        Scoutli may send notices to the Customer’s email contact points provided by the Customer.
                        Scoutli may send notifications to Customers’ notification channels through third-party
                        notification channels/apps provided by Customers. Customers may send notices pursuant to the
                        General Terms to Scoutli at <b>team@scoutli.co</b>. Notices shall be deemed received 24 hours
                        after they are sent.
                    </p>

                    <h4>Assignment & Successors</h4>

                    <p>
                        The General Terms shall be binding upon and inure to the benefit of the Parties’ respective
                        successors and assigns.
                    </p>

                    <h4>Waiver</h4>

                    <p>
                        No waiver by either party of any default in performance on the part of the other Party shall
                        constitute a waiver of any subsequent breach or default by the defaulting Party.
                    </p>

                    <h4>Relationship of the Parties</h4>

                    <p>
                        The Parties are independent contractors. The General Terms do not create a partnership,
                        franchise, joint venture, agency, fiduciary, or employment relationship between the Parties.
                    </p>

                    <h4>Confidentiality</h4>

                    <p>
                        All aspects of the arbitration proceeding shall be strictly confidential. The parties agree to
                        maintain confidentiality unless otherwise required by law. This paragraph shall not prevent a
                        party from submitting to a court of law any information necessary to enforce this Agreement, to
                        enforce an arbitration award, or to seek injunctive or equitable relief.
                    </p>

                    <h4>Severability</h4>

                    <p>
                        If any part or parts of this Arbitration Agreement are found under the law to be invalid or
                        unenforceable by a court of competent jurisdiction, then such specific part or parts shall be of
                        no force and effect and shall be severed and the remainder of the Agreement shall continue in
                        full force and effect.
                    </p>

                    <h4>
                        Translation Interpretation
                    </h4>

                    <p>
                        These Terms and Conditions may have been translated if We have made them available to You on our
                        Service. You agree that the original English text shall prevail in the case of a dispute.
                    </p>

                    <h4>Right to Waive</h4>

                    <p>
                        Any or all of the rights and limitations set forth in this Arbitration Agreement may be waived
                        by the party against whom the claim is asserted. Such waiver shall not waive or affect any other
                        portion of this Arbitration Agreement.
                    </p>

                    <h4>Survival of Agreement</h4>

                    <p>
                        This Arbitration Agreement will survive the termination of your relationship with the Company.
                    </p>

                    <h4>Emergency Equitable Relief</h4>

                    <p>
                        Anyhow the foregoing, either party may seek emergency equitable relief before a state or federal
                        court in order to maintain the status quo pending arbitration. A request for interim measures
                        shall not be deemed a waiver of any other rights or obligations under this Arbitration
                        Agreement.
                    </p>

                    <h4>Claims Not Subject to Arbitration</h4>

                    <p>
                        Notwithstanding the foregoing, claims of defamation, violation of the Computer Fraud and Abuse
                        Act, and infringement or misappropriation of the other party's patent, copyright, trademark, or
                        trade secrets shall not be subject to this Arbitration Agreement.
                    </p>

                    <h4>Electronic Communications</h4>

                    <p>
                        The communications between you and Company use electronic means, whether you use Scoutli or send
                        us emails, or whether the Company posts notices on Scoutli or communicates with you via email.
                        For contractual purposes, you (a) consent to receive communications from Company in an
                        electronic form; and (b) agree that all terms and conditions, agreements, notices, disclosures,
                        and other communications that Company provides to you electronically satisfy any legal
                        obligation that such communications would satisfy if it were in a hard copywriting.
                    </p>

                    <h4>Copyright/Trademark Information</h4>

                    <p>All rights reserved. All trademarks, logos, and service marks displayed on Scoutli are our
                        property or the property of other third parties. You are not permitted to use these Marks
                        without our prior written consent or the consent of such a third party that may own the
                        Marks.
                    </p>

                    <h4>Acknowledgment</h4>

                    <p>
                        BY CONTINUING TO ACCESS OR USING SERVICE OR OTHER SERVICES PROVIDED BY US, YOU ACKNOWLEDGE THAT
                        YOU HAVE READ THESE TERMS OF SERVICE AND AGREE TO BE BOUND BY THEM.
                    </p>

                    <h4>Contact Us</h4>

                    <p>
                        If you have any questions about these terms of service, please contact us:
                    </p>

                    <p>By email: <b>team@scoutli.co</b>.</p>
                </div>
            </div>
        </div>
    )
}

export default Terms;